import { Component, OnInit } from "@angular/core";
import { Activity, ActivityService } from "@rubbl-activity";

@Component({
  selector: "app-renter-tax",
  templateUrl: "./renter-tax.component.html",
  styleUrls: ["./renter-tax.component.scss"],
})
export class RenterTaxComponent implements OnInit {
  activity: Activity;
  constructor(private activityService: ActivityService) {}

  ngOnInit(): void {
    this.activity = this.activityService.getActivityByCode("TAX-EXEMPTION");
  }
}
